<ul class="preset-ranges-list">
  <li *ngFor="let item of items" (click)="onItemClick(item)" [class.selected]="item.selected">
    {{item.title}}
  </li>  
</ul>

